
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/governance/antisocial",
      function () {
        return require("private-next-pages/ir/governance/antisocial.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/governance/antisocial"])
      });
    }
  